/** Player lists page in twenties, so a page count converts to a player count. */
export const RESULT_PAGE_SIZE = 20;
/**
 * How many players a filter would return, from its first page.
 *
 * The endpoint reports `totalPages`, never a total. One page means we hold the
 * whole result, so its length is exact. More than one, and only the last page
 * is partial, so `(totalPages - 1) * RESULT_PAGE_SIZE` is a floor, shown as
 * "1,260+" rather than a quietly rounded figure.
 */
export const resultCountFromPage = ({ playersOnPage, totalPages, }) => totalPages > 1
    ? { count: (totalPages - 1) * RESULT_PAGE_SIZE, approximate: true }
    : { count: playersOnPage, approximate: false };
//# sourceMappingURL=resultCount.js.map